<template>
  <div>
    
    <v-form ref="inputForm" @submit.prevent="">

      <div v-html="$let('EmploymentSubSectionTitle')" class="subtitle-enquiry mb-5"></div>

      <v-row>
        <v-col cols="12" md="6">
          <Combobox
            v-if="elsInUse.EmploymentStatusID"
            v-model="employmentStatus"
            :returnObject="true"
            :items="employmentStatusDS" 
            :label="elsLabel.EmploymentStatusID"
            :helperText="elsHelperText.EmploymentStatusID"
            @input="_employmentStatusChange"
            :rules="[elsRequired.EmploymentStatusID ? rules.required : true]">
          </Combobox>
        </v-col>
        <v-col cols="12" md="6">
          <Combobox
            v-if="elsInUse.OccupationID && enforceEmploymentDetails"
            v-model="model.occupationID" 
            :items="occupationDS" 
            :label="elsLabel.OccupationID"
            :helperText="elsHelperText.OccupationID"
            :rules="[elsRequired.OccupationID ? rules.required : true]">
          </Combobox>
        </v-col>
      </v-row>

      <v-expand-transition>
        <div v-if="enforceEmploymentDetails">
          <v-row>
            <v-col cols="12" md="6">
              <TextField 
                maxlength="100"
                v-model="model.memberEmployer" 
                v-if="elsInUse.MemberEmployer"
                :label="elsLabel.MemberEmployer"
                :helperText="elsHelperText.MemberEmployer"
                :rules="[rules.text, elsRequired.MemberEmployer ? rules.required : true]">
              </TextField>
            </v-col>

            <v-col cols="12" md="6">
              <TextField 
                type="number"
                :min="0"
                :max="99"
                v-model="model.employmentLength" 
                v-if="elsInUse.EmploymentLength"
                :label="elsLabel.EmploymentLength"
                :helperText="elsHelperText.EmploymentLength"
                :rules="[rules.numeric, elsRequired.EmploymentLength ? rules.required : true]">
              </TextField>
            </v-col>
          </v-row>

          <PostalAddress
            :title="$let('EmployerAddressSubSectionTitle')"
            :class="'mt-5'"
            v-model="model.memberEmployerAddress"
            propertyModelName="MemberEmployerAddress"
            :rules="rules">
          </PostalAddress>
          
        </div>
      </v-expand-transition>

      <StepperButtons 
        @continueClick="_stepperContinue"
        @backClick="_stepperBack">
      </StepperButtons>

    </v-form>

  </div>
</template>

<script>

  import { mapGetters } from "vuex";
  import TextField from '@/shared/components/text-field.vue'
  import Combobox from '@/shared/components/combobox.vue';
  import StepperButtons from './stepper-buttons.vue'
  import PostalAddress from './postal-address.vue'
  import opmGeneric from '../utils/generic.js';

  export default {
    name: 'EmploymentDetails',
    components: { 
      PostalAddress,
      StepperButtons, 
      TextField, 
      Combobox
    },
    props: {
      rules: { type: Object },
    },    
    emits: ["continueClick", "backClick"],
    data() {
      return {
        employmentStatusDS: [],
        occupationDS: [],
        enforceEmploymentDetails: false,
        employmentStatus: undefined,
        model: {
          employmentStatusID: undefined,
          occupationID: undefined,
          memberEmployer: undefined,
          employmentLength: undefined,
          memberEmployerAddress: {}
        }
      };
    },

    async created() { 
      opmGeneric.setElementsConfig(this, this.elementsConfig); 
      // DropdownLists sources
      this.employmentStatusDS = this.referenceData ? this.referenceData.EmploymentStatus : [];
      this.occupationDS = this.referenceData ? this.referenceData.Occupations : [];
    },

    methods: {
      _employmentStatusChange($event) {
        this.enforceEmploymentDetails = $event.EnforceEmploymentDetails;
      },

      _stepperContinue() { 
        this.model.employmentStatusID = this.employmentStatus?.ID; // from Object to ID
        this.$emit("continueClick", this.model, this.$refs.inputForm); 
      },
      
      _stepperBack() { 
        this.$emit("backClick"); 
      },
      
    },
    computed: {
      ...mapGetters(["referenceData", "elementsConfig"]),
    }
  };
</script>

<style lang="scss" scoped>

</style>